import { BaseProvider, createDarkTheme, createLightTheme } from 'baseui';
import { ALIGNMENT, BEHAVIOR, Cell, Grid } from 'baseui/layout-grid';
import { StyledLink } from 'baseui/link';
import { h } from 'preact';
import { Client as Styletron } from 'styletron-engine-atomic';
import { Provider as StyletronProvider } from 'styletron-react';

import useDarkModePreference from '../utils/hooks/useDarkModePreference';
import InstructionsModal from './InstructionsModal';
import RoutePlanner from './RoutePlanner';

const STYLETRON = new Styletron();
const THEMES = {
    DARK: createDarkTheme(),
    LIGHT: createLightTheme(),
};

export default function App() {
    const darkMode = useDarkModePreference();

    return (
        <StyletronProvider value={STYLETRON}>
            <BaseProvider theme={darkMode ? THEMES.DARK : THEMES.LIGHT} zIndex={1000} overrides={{
                AppContainer: { style: () => ({ height: '100%', overflow: 'hidden auto' }) },
            }}>
                <Grid align={ALIGNMENT.center} behavior={BEHAVIOR.fluid} overrides={{
                    Grid: { style: () => ({ alignContent: 'space-between', height: '100%', }) },
                    GridWrapper: { style: () => ({ height: '100%' }) }
                }}>
                    <Cell span={12}>{/* TODO: do we need a header of any kind? */}</Cell>
                    <Cell span={12}><RoutePlanner /></Cell>
                    <Cell span={12} overrides={{ Cell: { style: {
                        alignItems: 'center',
                        display: 'flex !important',
                        gap: '8px',
                        justifyContent: 'space-between',
                        paddingBottom: '1rem',
                    }}}}>
                        <InstructionsModal />
                        <span className="copyright">
                            &copy; Coffee Route, 2023.&nbsp;
                            <StyledLink animateUnderline href="https://buymeacoffee.com" target="_blank">
                                Buy&nbsp;<em>us</em>&nbsp;a coffee.
                            </StyledLink>
                        </span>
                    </Cell>
                </Grid>
            </BaseProvider>
        </StyletronProvider>
    );
}
